
export default {
  context: {},
  user: {
    profile_image: {
      path: null,
    },
  },
  page: {},
  cart: [],
  sidebar: {
    lastUpdate: null,
    jobs: null,
    tia: null,
  },
};



// WEBPACK FOOTER //
// ./src/js/store/state.js